var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeakerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.00868H5.42008L13.5738 0.0742188V23.9267L5.42008 16.9923H0V7.00868ZM16.6373 5.87752C18.2397 7.54966 19.0567 9.58244 19.0881 11.9759C19.0881 14.271 18.2712 16.2382 16.6373 17.8775L14.9877 16.1071C16.1189 14.9267 16.6844 13.5333 16.6844 11.9267C16.6844 10.2874 16.1188 8.86116 14.9877 7.64802L16.6373 5.87752ZM19.4652 2.97588C21.8217 5.4349 23 8.40212 23 11.8775C23 15.3529 21.8217 18.3365 19.4652 20.8283L17.7213 19.0087C19.6066 17.0743 20.5492 14.7054 20.5492 11.9022C20.5492 9.09888 19.6066 6.71362 17.7213 4.7464L19.4652 2.97588Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerIcon);
export default __webpack_public_path__ + "static/media/speaker-icon.83a867341beb3a8ba213344977e1c6fd.svg";
export { ForwardRef as ReactComponent };